// @flow

export type ApiParamsType = {|
  body?: Object,
  method?: 'get' | 'post' | 'put' | 'delete'
|}

export type HttpParamsType = {|
  ...ApiParamsType,
  url: string,
  auth?: {
    username: string,
    password: string
  },
  retries?: number
|}

function httpCallRetry (params: HttpParamsType): Promise<*> {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest()
    xhr.open(params.method || 'get', params.url, true)
    xhr.setRequestHeader('Content-Type', 'application/json')
    if (params.auth) {
      xhr.setRequestHeader('Authorization', 'Basic ' + window.btoa(`${params.auth.username}:${params.auth.password}`))
      xhr.withCredentials = true
    }
    xhr.timeout = 10000
    xhr.onload = () => {
      if (xhr.readyState === 4) {
        if (xhr.status === 204) {
          resolve()
        } else if (xhr.status >= 200 && xhr.status < 400) {
          try {
            const response = JSON.parse(xhr.responseText)
            resolve(response)
          } catch (err) {
            reject(err)
          }
        } else {
          reject(new Error(xhr.responseText))
        }
      }
    }
    xhr.ontimeout = (err) => reject(err)
    xhr.onerror = (err) => reject(err)
    xhr.send(JSON.stringify(params.body))
  })
}

export function httpCall (params: HttpParamsType, retries: number = 0): Promise<*> {
  if (!params.retries || params.retries === retries) {
    return httpCallRetry(params)
  } else {
    return httpCallRetry(params).catch(() => httpCall(params, retries + 1))
  }
}
